import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  style: {"color":"red"}
}

import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { allOrderAgentDetails} from '../../api'
  
 
  
export default /*#__PURE__*/_defineComponent({
  __name: 'detailsList',
  setup(__props) {

  const searchSelection = ref("")
  const loading = ref(false);
  
  const dataSource = ref([]);
  
  const selectedKeys = ref([]);
  
  const page = reactive({ current: 1, limit: 10, total: 0 });

  const search = reactive({
    key: searchSelection,
  })
  
  const columns = ref([
   
    { title: "订单号", key: "orderId", align: "center"}, 
    { title: "状态", key: "state", align: "center" , customSlot: "state"}, 
    { title: "总收益", key: "generalAgentIncome", align: "center" },  
    { title: "代理收益", key: "agencyIncome", align: "center" },   
    { title: "代理比例", key: "agentProportion", align: "center" }, 
    { title: "平台", key: "platformId", align: "center" },  
    { title: "注册时间", key: "addTime", align: "center" }, 
  ]);
  
  const getAllOrderDetails = () => {
    loading.value = true;
    var data = { "page": page.current, "limit": page.limit, "key": search.key };
    allOrderAgentDetails(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllOrderDetails();
  
  const change = (page: any) => {
    getAllOrderDetails();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
   

  
return (_ctx: any,_cache: any) => {
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!

  return (_openBlock(), _createBlock(_component_lay_row, { space: "10" }, {
    default: _withCtx(() => [
      _createVNode(_component_lay_col, { md: "24" }, {
        default: _withCtx(() => [
          _createVNode(_component_lay_panel, null, {
            default: _withCtx(() => [
              _createVNode(_component_lay_table, {
                page: page,
                height: '100%',
                columns: columns.value,
                loading: loading.value,
                "data-source": dataSource.value,
                "selected-keys": selectedKeys.value,
                "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((selectedKeys).value = $event)),
                onChange: change,
                onSortChange: sortChange
              }, {
                state: _withCtx(({ row }) => [
                  (row.state==1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, "正常"))
                    : (row.state==2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "用户退单"))
                      : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})